module.exports = __webpack_public_path__ + "img/google-site-seguro.8fecb07d.png";